import { Form, Formik } from "formik";
import { useState } from "react";
import { GoArrowDown } from "react-icons/go";
import { toast } from "react-toastify";
import { ERROR_MSG, ROLE } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import { CONSUMER_MEMBER_ADD_ENDPOINT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { updatePasswordConfirmation } from "../../../resources/js/images";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import Dropdown from "../../../shared/ui/Dropdown/Dropdown";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import { addUserValidator } from "../../../shared/ui/Form/schema";
import Confirmation from "./Confirmation";

const roles = [ROLE.CONSUMER_ADMIN, ROLE.CONSUMER_USER];

const AddUser = ({ onClick }) => {
    const [role, setRole] = useState(roles[0]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const { state, dispatch } = useContextState();

    const handleSubmit = async (values, actions) => {
        let plantId = state?.user?.plant?.plantId;
        if (plantId) {
            let body = {
                plantId: plantId,
                name: values?.name,
                email: values?.email,
                phoneNumber: `91${values.phone}`,
                role,
            };
            try {
                dispatch({ type: SET_LOADER });
                await request.authPost({
                    endpoint: CONSUMER_MEMBER_ADD_ENDPOINT,
                    body,
                });
                actions.resetForm();
                setRole(role[0]);
                setShowConfirmation(true);
                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        } else {
            toast.error("Plant id not found");
        }
    };

    const initialValues = {
        name: "",
        email: "",
        phone: "",
    };
    return (
        <div>
            <Formik
                onSubmit={handleSubmit}
                validationSchema={addUserValidator}
                initialValues={initialValues}
            >
                {({ isSubmitting, isValid, dirty }) => (
                    <Form>
                        <div className="flex flex-col gap-2">
                            <div className="border-b border-blue-200 ">
                                <P className="text-blue border-b-2 border-blue inline-block font-vietnam ">
                                    Add Member
                                </P>
                            </div>
                            <FormikLabeledInput
                                label="Name"
                                name="name"
                                type="text"
                            />
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div>
                                    <p
                                        className="text-secondary font-normal text-sm sm:text-base xl:text-lg mb-0.8 font-vietnam"
                                        htmlFor={"role"}
                                    >
                                        Add Role{" "}
                                        <span className="text-red">*</span>
                                    </p>
                                    <Dropdown
                                        selected={role}
                                        onSelect={(v) => setRole(v)}
                                        data={roles}
                                        icon={<GoArrowDown />}
                                    />
                                </div>

                                <FormikLabeledInput
                                    label="Phone Number"
                                    name="phone"
                                    type="text"
                                />
                            </div>
                            <FormikLabeledInput
                                label="Email"
                                name="email"
                                type="text"
                            />

                            <Button
                                type="submit"
                                className="w-full mt-1 xl:mt-.5 2xl:mt-1 rounded-full py-0.8 mb-2 font-vietnam"
                                disabled={isSubmitting || !(isValid && dirty)}
                                isLoading={isSubmitting}
                                loaderClass="w-2 h-2 lg:w-3 lg:h-3"
                            >
                                Request admin to add user
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>

            <BottomDrawer
                isOpen={showConfirmation}
                onClick={() => setShowConfirmation(false)}
            >
                <div className="bg-white pt-2 rounded-t-2">
                    <Container className="pb-6.4">
                        <Confirmation
                            img={updatePasswordConfirmation}
                            heading="Add User"
                            message="Your request has been sent successfully. Please wait for the admin to accept it."
                        >
                            <div className="flex justify-center w-full mt-1">
                                <Button
                                    className="font-vietnam"
                                    onClick={() => {
                                        setShowConfirmation(false);

                                        onClick();
                                    }}
                                >
                                    Go back to profile
                                </Button>
                            </div>
                        </Confirmation>
                    </Container>
                </div>
            </BottomDrawer>
        </div>
    );
};

export default AddUser;
